export const BENEFICIARIES_ADD = 'beneficiaries/add';
export const BENEFICIARIES_CANCEL_ADD = 'beneficiaries/cancel_add';
export const BENEFICIARIES_EDIT = 'beneficiaries/edit';
export const BENEFICIARIES_CANCEL_EDIT = 'beneficiaries/cancel_edit';
export const BENEFICIARIES_SAVE = 'beneficiaries/save';
export const BENEFICIARIES_SAVE_FAILED = 'beneficiaries/save/failed';
export const BENEFICIARIES_SAVE_SUCCESS = 'beneficiaries/save/sucess';
export const BENEFICIARIES_SAVE_PAPERWORK = 'beneficiaries/save_paperwork';
export const BENEFICIARIES_SAVE_PAPERWORK_FAILED = 'beneficiaries/save_paperwork/failed';
export const BENEFICIARIES_SAVE_PAPERWORK_SUCCESS = 'beneficiaries/save_paperwork/sucess';
export const BENEFICIARIES_REMOVE = 'beneficiaries/remove';
export const BENEFICIARIES_REMOVE_FAILED = 'beneficiaries/remove/failed';
export const BENEFICIARIES_REMOVE_SUCCESS = 'beneficiaries/remove/success';
export const BENEFICIARIES_CONFIRM = 'beneficiaires/confirm';
export const BENEFICIARIES_CONFIRM_FAILED = 'beneficiaires/confirm/failed';
export const BENEFICIARIES_CONFIRM_SUCCESS = 'beneficiaires/confirm/success';
export const BENEFICIARIES_CANCEL_ALL = 'beneficiaries/cancel_all';
export const BENEFICIARIES_START = 'beneficiaries/start';
export const BENEFICIARIES_START_FAILED = 'beneficiaries/start/failed';
export const BENEFICIARIES_START_SUCCESS = 'beneficiaries/start/success';

export const ActionType = {
    BENEFICIARIES_ADD,
    BENEFICIARIES_CANCEL_ADD,
    BENEFICIARIES_EDIT,
    BENEFICIARIES_CANCEL_EDIT,
    BENEFICIARIES_SAVE,
    BENEFICIARIES_SAVE_FAILED,
    BENEFICIARIES_SAVE_SUCCESS,
    BENEFICIARIES_SAVE_PAPERWORK,
    BENEFICIARIES_SAVE_PAPERWORK_FAILED,
    BENEFICIARIES_SAVE_PAPERWORK_SUCCESS,
    BENEFICIARIES_REMOVE,
    BENEFICIARIES_REMOVE_FAILED,
    BENEFICIARIES_REMOVE_SUCCESS,
    BENEFICIARIES_CONFIRM,
    BENEFICIARIES_CONFIRM_FAILED,
    BENEFICIARIES_CONFIRM_SUCCESS,
    BENEFICIARIES_CANCEL_ALL,
    BENEFICIARIES_START,
    BENEFICIARIES_START_FAILED,
    BENEFICIARIES_START_SUCCESS,
} as const;

export type ActionType = (typeof ActionType)[keyof typeof ActionType];
